module.exports = __webpack_public_path__ + "static/media/paper-matching-alt.08add88a.svg";